export function data(state,data){
    state.data = data
}

export function disableForm(state,data){
    state.disableForm = data
}

export function enums(state,enums){
    state.enums = enums
}

export function pagination(state,pagination){
    state.pagination = pagination
}

export function limpaData(state){
    state.disableForm = false;
    state.data = JSON.parse(JSON.stringify(state.dataDefault));       
}

export function novoValor(state){    

    let max = 0;
    for(let x=0;x<state.data.valores.length;x++){
        const z = Number ( state.data.valores[x].ordem );
        if( max < z){
            max = z;
        }
    }

    max +=  1
    let novoValor =JSON.parse(JSON.stringify(state.enumValueDefault));
    novoValor.ordem = max;
    state.data.valores.push( novoValor );       
}